// import { createRouter, createWebHistory } from 'vue-router'
import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/anth.js'
Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录 - 麦好火'
    }
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: () => import('@/views/Login/protocol/index.vue'),
    meta: {
      title: '麦好火平台服务协议 - 麦好火'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '首页 - 麦好火'
    }
  },
  {
    path: '/videoList',
    name: 'videoList',
    component: () => import('@/views/index/videoList.vue'),
    meta: {
      title: '视频列表 - 麦好火'
    }
  },
  {
    path: '/goodsList',
    name: 'goodsList',
    component: () => import('@/views/index/goodsList.vue'),
    meta: {
      title: '商品列表 - 麦好火'
    }
  },
  {
    path: '/selection',
    name: 'selection',
    component: () => import('@/views/index/selection.vue'),
    meta: {
      title: '选品中心 - 麦好火'
    }
  },
  {
    path: '/merchant',
    name: 'merchant',
    component: () => import('@/views/index/merchant.vue'),
    meta: {
      title: '商家入驻 - 麦好火'
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/index/itemDetail.vue'),
    meta: {
      title: '商品详情 - 麦好火'
    }
  },
  {
    path: '/individuality',
    name: 'individuality',
    redirect: '/goods/order',
    component: () => import('@/views/individuality/individuality.vue'),
    meta: {
      title: '个人中心 - 麦好火'
    },
    children: [
      {
        path: '/goods/order',
        name: 'goodsOrder',
        component: () =>
          import('@/views/individuality/components/goods-order.vue'),
        meta: {
          title: '个人中心 - 商品订单'
        }
      },
      {
        path: '/goods/order/detail',
        name: 'goodsOrderDetail',
        component: () =>
          import('@/views/individuality/components/goods/order-detail.vue'),
        meta: {
          title: '个人中心 - 商品订单详情'
        }
      },
      {
        path: '/vidoe/order',
        name: 'vidoeOrder',
        component: () =>
          import('@/views/individuality/components/vidoe-order.vue'),
        meta: {
          title: '个人中心 - 视频订单'
        }
      },
      {
        path: '/vidoe/order/detail',
        name: 'vidoeOrderDetail',
        component: () =>
          import('@/views/individuality/components/vidoe/vidoe-info.vue'),
        meta: {
          title: '个人中心 - 视频订单详情'
        }
      },
      {
        path: '/vidoe/script',
        name: 'vidoeScript',
        component: () =>
          import('@/views/individuality/components/vidoe/vidoe-script.vue'),
        meta: {
          title: '个人中心 - 脚本视频'
        }
      },
      {
        path: '/receive/location',
        name: 'receiveLocation',
        component: () =>
          import('@/views/individuality/components/receive-location.vue'),
        meta: {
          title: '个人中心 - 收货地址'
        }
      },
      {
        path: '/person/info',
        name: 'personInfo',
        component: () =>
          import('@/views/individuality/components/person-info.vue'),
        meta: {
          title: '个人中心 - 个人信息'
        }
      }
    ]
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/index/video.vue'),
    meta: {
      title: '视频详情 - 麦好火'
    }
  },
  {
    path: '/test',
    component: () => import('@/components/videoPlayer/index.vue')
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import('@/views/individuality/refund.vue'),
    meta: {
      title: '个人中心 - 麦好火'
    }
  },
  {
    path: '/ensure',
    name: 'orderEnsure',
    component: () =>
      import('@/views/individuality/components/vidoe/order-ensure.vue'),
    meta: {
      title: '订单确认 - 麦好火'
    }
  },
  {
    path: '/pay/success',
    name: 'paySuccess',
    component: () =>
      import('@/views/individuality/components/pay/pay_success.vue'),
    meta: {
      title: '付款成功 - 麦好火'
    }
  }
]

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
//   scrollBehavior () {
//     document.documentElement.scrollTop = 0
//   }
// })

// router.beforeEach((to) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   // document.documentElement.scrollTop = 0
// })
const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (
    to.path === '/goods/order' ||
    to.path === '/goods/order/detail' ||
    to.path === '/vidoe/order' ||
    to.path === '/vidoe/order/detail' ||
    to.path === '/vidoe/script' ||
    to.path === '/receive/location' ||
    to.path === '/person/info' ||
    to.path === '/refund' ||
    to.path === '/ensure'
  ) {
    if (getToken()) next()
    else {
      next('/login')
    }
  } else if (to.path === '/login') {
    console.log('login', getToken())
    if (!getToken()) next()
    else next(from.path)
  } else next()
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js